import { getFocusRingBorderCSS } from '@ardoq/style-helpers';
import styled, { css } from 'styled-components';
import { colors, fade, shadowS, space } from '@ardoq/design-tokens';
import { LabelProps } from '../Label/Label';
import { text1 } from '@ardoq/typography';
import { HiddenCheckbox } from '../common/HiddenCheckbox';

interface SwitchLabelProps extends LabelProps {
  $isChecked: boolean;
  $isDisabled?: boolean;
  $isLabelHidden: boolean;
}

const TOGGLE_WIDTH = 34;

export const SwitchLabel = styled.label<SwitchLabelProps>`
  ${text1};
  line-height: 24px;
  display: inline;
  vertical-align: middle;
  cursor: pointer;
  z-index: 0;

  ${({ $isLabelHidden }) =>
    $isLabelHidden
      ? css`
          padding: 0 0 0 ${TOGGLE_WIDTH}px;
        `
      : css`
          padding: 0 0 0 ${TOGGLE_WIDTH + 8}px;
        `}

  ${({ $isChecked }) =>
    $isChecked
      ? css`
          &:before {
            background-color: ${colors.surfaceSuccessStrong};
          }
          &:after {
            background-color: ${colors.surfaceDefault};
          }
        `
      : css`
          &:before {
            background-color: ${colors.componentSwitchSurfaceDefault};
          }
          &:after {
            background-color: ${colors.surfaceDefault};
          }
        `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      pointer-events: none;
      color: ${colors.textDisabled};
      &:before {
        opacity: 33%;
      }
    `}

  &:before {
    content: '';
    position: absolute;
    top: 2px;
    left: 0;
    width: ${TOGGLE_WIDTH}px;
    height: 20px;
    border-radius: 14px;
    z-index: 1;
    ${fade}
    transition-property: background-color;
  }

  &:after {
    content: '';
    position: absolute;
    top: 4px;
    left: 2px;
    width: ${space.medium};
    height: ${space.medium};
    box-shadow: ${shadowS};
    border-radius: 14px;
    z-index: 2;
    ${fade}
    transition-property: left, background-color, border-color;

    ${props =>
      props.$isChecked &&
      css`
        left: 16px;
        border-color: transparent;
      `}
  }
`;

export const Container = styled.div<{ $isDisabled?: boolean }>`
  display: inline-flex;
  position: relative;
  line-height: 24px;
  height: 24px;

  &&:has(${HiddenCheckbox}:focus-visible) {
    ${SwitchLabel}:before {
      ${getFocusRingBorderCSS()}
    }
  }

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      pointer-events: none;
    `}
`;
